import { indirectEval, type InstanceSettings, type OrganizationSettings } from '@lib/main.lib'

export function getPreviewUrl(url: string, pitcherSettings?: OrganizationSettings & InstanceSettings) {
  try {
    const transformerFnStr = pitcherSettings?.section_thumbnail_url_transformer
    let transformerFn: (url: string) => string

    try {
      transformerFn = transformerFnStr ? indirectEval(`(${transformerFnStr})`) : null
    } catch (evalError) {
      console.error('Eval Error:', evalError)
      throw new Error('Failed to evaluate transformer function')
    }

    return transformerFn ? transformerFn(url) : url
  } catch (e) {
    return url
  }
}

export function getAppConfigFromAppSource(source: string): string | undefined {
  const lastIndex = source.lastIndexOf('/index.html')

  if (lastIndex === -1) {
    return undefined
  }

  return source.slice(0, lastIndex) + '/app.json'
}
